import { ConsentHelper } from '../../common/ConsentHub';

export default function Newsletter() {
  this.MAILING_LIST_ID = "1275007";
  this.params = {
    useGdpr: FEATURE_FLAG_USE_GDPR,
    needsConsent: false,
    site: "atlassian",
    subscriptionKey: "atlassian.gitInsidersNewsletter"
  }
  this.consentHub = null;

  this.bindEvents();
}

Newsletter.prototype.addMultipleListeners = function(element,events,handler){
  if (!(events instanceof Array)){
    return false;
  }
  var handlerFn = function(e) {
    handler.apply(this, []);
  }
  for (var i=0; i<events.length; i+=1) {
    element.addEventListener(events[i], handlerFn, false);
  }
}

Newsletter.prototype.submitForm = function(event) {
  event.preventDefault();
  var self = this;
  var form = event.target.tagName == "FORM" ? event.target : event.target.closest('form');
  var button = form.querySelector('[type="submit"]');
  var success = function () {
    form.classList.remove("form-is-processing");
    button.classList.add("icon-email-success");
    button.classList.remove("icon-email-error", "icon-email-submit");
  };
  var fail = function () {
    form.classList.remove("form-is-processing");
    button.classList.remove("icon-email-success");
    button.classList.add("icon-email-error", "icon-email-submit");
  };
  form.classList.add("form-is-processing");
  if (self.params.useGdpr) {
    self.consentHub = new ConsentHelper(self.params, form).then((consentHub) => {
      consentHub.submitForm(success, fail);
    }).catch(() => {
      fail();
    });
  }

  if (!self.params.useGdpr) {
    var email = form.querySelector("._input").value;
    var exactTargetUrl = `https://www.atlassian.com/apis/exact-target/${email}/subscribe?mailingListId=${self.MAILING_LIST_ID}`;

    var postNewsletter = new XMLHttpRequest();
    postNewsletter.open('POST', exactTargetUrl, true);
    postNewsletter.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    postNewsletter.onreadystatechange = function () {
      if (postNewsletter.status === 200) {
        success();
      } else {
        fail();
      }
    };
    postNewsletter.send();

  }
}

Newsletter.prototype.emailValidate = function(field) {
  var email = field.value;
  if (!!email.match(/^(.+?)@(.+?)\.(.+?)$/)) {
    field.parentNode.classList.add("is-valid");
  } else {
    field.parentNode.classList.remove("is-valid");
  }
}

Newsletter.prototype.bindEvents = function() {
  var self = this;
  var formNewsletter = document.querySelectorAll('form.newsletter');

  for (var f = 0; f < formNewsletter.length; f++) {
    var individualForm = formNewsletter[f];

    individualForm.addEventListener("submit", function(event) {
      self.submitForm(event);
    });

    individualForm.querySelector('._input').addEventListener("focus", function() {
      this.parentNode.classList.add("is-focused");
    });

    individualForm.querySelector('._input').addEventListener("blur", function() {
      this.parentNode
      .classList.remove("is-focused");

    });

    this.addMultipleListeners(
      individualForm.querySelector('._input'),
      ["propertychange change click keyup input paste"],
      self.emailValidate,
      false);
  }
};
